// extracted by mini-css-extract-plugin
export default {"actions":"Share_actions__n7P39","active":"Share_active__cSm9R","button":"Share_button__2r-9D","body":"Share_body__Wq7pa","item":"Share_item__3U3HW"};